import { getDefaultLogger } from '../logger';

import type { AxiosError } from 'axios';

/**
 * 서버 로그를 적재하는 함수입니다.
 *
 * @param error - AxiosError 객체
 * @param lowPriorityErrorCodes - 무시할 에러 코드 배열 - default [401, 403, 404]
 */
const captureServerAxiosError = (
  error: AxiosError,
  lowPriorityErrorCodes: number[] = [401, 403, 404],
  lowPriorityErrorPaths: string[] = ['/v2/config/maintenance'],
) => {
  const { name, message, code, config, response } = error;
  const status = response?.status;
  const responseData =
    typeof response?.data === 'string' ? { message: response?.data } : response?.data;
  const errorMessage = message || 'Unknown error';
  const errorPath = config?.url || 'Unknown path';
  const userToken = config?.headers['x-auth-token'] || 'No token';

  // 로그 데이터 구성
  const logData = {
    server_axios: {
      error: {
        type: response ? 'axios_error' : 'network_error',
        name: name || '-', // 예: UnauthorizedError
        code: code || 'No code', // 예: ERR_BAD_REQUEST
        message: errorMessage, // 예: Request failed with status code 401
        stack_trace: error?.stack || 'No stack trace',
      },
      request: {
        method: config?.method?.toUpperCase() || 'UNKNOWN_METHOD',
        url: errorPath,
        timeout: config?.timeout || 'No timeout',
        headers: config?.headers || {},
      },
      response: response
        ? {
            status: `${response.status} (${response.statusText || '-'})`, // 예: 401 (Unauthorized)
            data: response.data ? responseData : {},
            headers: response.headers || {},
          }
        : {
            status: 'No response',
          },
    },
    user: {
      token: userToken,
    },
  };

  // 기본 로거 설정
  const logger = getDefaultLogger({
    type: 'server_axios',
    url: errorPath,
    custom: {
      ...logData,
    },
  });

  // 로그 기록
  if (status && lowPriorityErrorCodes.includes(status)) {
    logger.info(errorMessage);
  } else if (lowPriorityErrorPaths.includes(errorPath)) {
    logger.info(errorMessage);
  } else {
    logger.warn(errorMessage);
  }
};

export default captureServerAxiosError;
